export const formatDocumentTypeRes = (data) => {
  return {
    id: data.documentTypeId,
    programId: data.programId,
    name: data.name,
    notes: data.notes,
    isRequired: data.isRequired,
    link: data.link,
  }
}